module.exports = __webpack_public_path__ + "static/media/bball-side.7aa26ca9.png";